module.exports = __webpack_public_path__ + "img/ps-14.89495e2d.jpg";